import React, { useEffect, useState } from "react"
import SharedTable from "../Common/table"
import formatDate from "../../helpers/format_date"
import moment from "moment"
import NewJob from "./new_job"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { withRouter } from 'react-router-dom'
import { getFacilityStaff } from "../../api/admin"
const Jobs = ({staff, getFacilityStaff}) => {
    const [checkedFilters, setCheckedFilters] = useState([])
    useEffect(() => {
        getFacilityStaff();
    }, [])

    return (
  <SharedTable
    collection={"jobs"}
    queries={{ status: "Pending", parent_job_id: null, is_parent_job: true }}
    fetchURL={"admin/open-jobs"}
    includeSearch={true}
    includeTitle={"Open Jobs"}
    includeFilter={true}
    filters={[
      {
        label: "Assigned To",
        key: "assigned_to",
        options: staff.map((member) => ({
            value: member.id,
            label: member.full_name,
        }))
      }
    ]}
    newModelComponent={<NewJob/>}
    sortKey='due_date'
    sortDirection='ASC'
    tableKeys={[
      { text: "Project" },
      { text: "Job", key: "title" },
      { text: "Assigned To" },
      { text: "Due", key: "due_date" }
    ]}
    tableWidths={["auto", 300, 180, 220]}
    tableValues={[
      job =>
        <div>
          <b>
            {job.project_title}
          </b>
          <div className='block small'>
            {job.owner_name}
          </div>
        </div>,
      job =>
        <div>
          <b>
            {job.title}
          </b>
          <div className='block small'>
            {job.status} ({job.children_status.completion} completed)
            {job.children_status.overdue > 0 &&
              <span className='ml1 red'>
                &#8729; {job.children_status.overdue} Overdue
              </span>}
            {job.children_status.near_due > 0 &&
              <span className='ml1 orange'>
                &#8729; {job.children_status.near_due} Due Soon
              </span>}
          </div>
        </div>,
      job =>
        <div>
          <b>
            {job.operator_name}
          </b>
          <div className='block small'>
            {job.facility_name}
          </div>
        </div>,
      job =>
        <div>
          {job.due_date
            ? <b
              className={`${moment(job.due_date) < moment()
                ? "red"
                : moment(job.due_date) < moment().add(2, "days")
                  ? "orange"
                  : ""}`}>
              {formatDate(job.due_date, false)}
            </b>
            : "N/A"}
          <div className='block small'>
            Created: {formatDate(job.created_at)}
          </div>
        </div>
    ]}/>
    );
}

function mapStateToProps(state, context) {
  return {
    staff: state.admin.staff.list || [],
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getFacilityStaff: bindActionCreators(getFacilityStaff, dispatch),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Jobs))